import React from "react";
import classNames from "classnames/bind";
import { Button, Drawer, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Chatbot } from "../../../../assets/svg";
import { IconMoney } from "../../../../assets/svg/logo";
import { useRecruitment } from "../../../../context/RecruitmentContext";
import MobileHeader from "../components/header/MobileHeader";
import drawerStyles from "./modal.module.sass";
import listStyles from "../ChatBotRecruimentMobile.module.sass";

const cx = classNames.bind({ ...drawerStyles, ...listStyles });

const DRAWER_META_FIELDS = [
  { label: "Địa điểm", key: "location" },
  { label: "Số lượng cần tuyển", key: "quantity" },
  { label: "Kinh nghiệm", key: "experience" },
];

const DrawerJobCard = ({ campaign, active, onClick }) => (
  <button
    type="button"
    className={cx("drawerJobCard", { active })}
    onClick={onClick}
  >
    <h3 className={cx("jobCardTitle")}>{campaign.title}</h3>
    <p className={cx("jobCardDepartment")}>{campaign.department}</p>
    <div className={cx("jobCardMeta")}>
      {DRAWER_META_FIELDS.map((field) => (
        <div key={field.key} className={cx("metaLine")}>
          <span>{field.label}</span>
          <strong>{campaign[field.key] ?? "—"}</strong>
        </div>
      ))}
    </div>
    <div className={cx("salaryBadge")}>
      <IconMoney />
      {campaign.salaryRange}
    </div>
  </button>
);

const GeneralChatCard = ({ active, onClick }) => (
  <button
    type="button"
    className={cx("drawerJobCard", "drawerGeneralChatCard", { active })}
    onClick={onClick}
  >
    <div className={cx("generalChatCardHeader")}>
      <span className={cx("generalChatIcon")} aria-hidden="true">
        <Chatbot />
      </span>
      <div>
        <h3 className={cx("jobCardTitle")}>Trò chuyện chung</h3>
        <p className={cx("jobCardDepartment")}>
          Hỏi về quy trình, CV, phúc lợi, vị trí tuyển dụng
        </p>
      </div>
    </div>
  </button>
);

const MobileCampaignDrawer = ({
  open,
  onClose,
  campaigns,
  activeCampaignId,
  isGeneralChatActive = false,
  onOpenGeneralChat,
  onSelect,
}) => {
  const { searchInput, setSearchInput, handleSearch } = useRecruitment();

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="right"
      closable={false}
      className={cx("campaignDrawer")}
      title={null}
    >
      <MobileHeader variant="drawer" onMenuClick={onClose} />
      <div className={cx("searchRow")}>
        <Input
          className={cx("searchInput")}
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          placeholder="Tìm kiếm vị trí"
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          allowClear
        />
        <Button
          type="primary"
          className={cx("searchButton")}
          icon={<SearchOutlined />}
          onClick={handleSearch}
        />
      </div>
      {/* <h2 className={cx("listTitle")}>Danh sách tuyển dụng</h2> */}
      <div className={cx("drawerList")}>
        <GeneralChatCard
          active={isGeneralChatActive}
          onClick={onOpenGeneralChat}
        />
        {campaigns.map((item) => (
          <DrawerJobCard
            key={item.id}
            campaign={item}
            active={String(item.id) === String(activeCampaignId)}
            onClick={() => onSelect(item.id)}
          />
        ))}
      </div>
    </Drawer>
  );
};

export default MobileCampaignDrawer;
